import { useLogic } from './hooks';
import type { ImageSequencePlayerProps } from './types';

export function ImageSequencePlayer(props: ImageSequencePlayerProps) {
  const { className, style, onElementAnimationEnd, id } = props;
  const { canvasRef } = useLogic(props);

  return <canvas ref={canvasRef} className={className} id={id} style={style} onAnimationEnd={onElementAnimationEnd} />;
}
